const lang = {
  relation: {
    title: '您正在关联 %{shop} 和 PingPong Checkout',
    logged: '确认使用以下已登录账号继续吗？',
    login: '请先登录您的 PingPong Checkout 账户',
    continue: '继续',
    changeAccount: '更换其他账户'
  },
  selectWebsite: {
    tipTitle: '选择您想要授权至 %{shop} 的网站',
    tipSubtitle: '我们已为您筛选出可用的网站',
    otherTipNo1: '您将允许 %{shop} 查看您的以下信息：',
    otherTipNo2: '· PingPong Checkout 实名认证信息（包括但不限于公司信息、法人信息、注册人信息等）',
    otherTipNo3: '· PingPong Checkout网站信息（包括但不限于Acc ID、网址、网站状态等）',
    howToApplyHalf1: '点击“同意并授权”，即表示您同意与 %{shop} 共享您的信息。此信息的使用将遵守',
    shopifyRule: '%{shop} 《隐私条款》',
    pingPongRule: 'PingPong《隐私条款》',
    symbolAnd: '和',
    sureButton: '同意并授权',
    cancelButton: '取消',
    noTokenTip: '您没有通过获得%{shop}的授权，请获取授权后重试。',
    userWantsThisUrl: '网址：',
    userWantsThisAccId: 'Acc ID：',
    accIdBinded: '已绑定 %{shop} 账户。是否确认换绑？换绑后，如需发起其他交易（如退款），请登录PingPong Checkout后台操作。',
    webBinded: '当前 %{shop} 账户已绑定其他网站，是否确认换绑？换绑后，如需发起其他交易（如退款），请登录PingPong Checkout后台操作。',
    accIdGatewayBinded: '已绑定 %{shop} 账户。是否确认换绑？',
    webGatewayBinded: '当前 %{shop} 账户已绑定其他网站，是否确认换绑？',
    loadingTip: '执行中...',
    attention: '注意'
  },
  hasNone: {
    tips: '该账号还未添加店铺，请先至PingPong Checkout后台提交网站信息，再重新授权。',
    sureButton: '添加网站',
    cancelButton: '取消'
  },
  loading: {
    doing: '正在授权中...',
    success: '授权成功',
    successTip1: '您即将离开PingPong Checkout...',
    successTip2: '无法跳转？点这里',
    failed: '授权失败',
    failedTip1: '网络发生错误',
    failedTip2: '重试'
  },
  selectRegion: {
    tipSubtitle: '请选择您的主体地区',
    tip: '如果商户主体为非美国，请不要选择美国地区。',
    sureButton: '确认',
    cancelButton: '取消',
  }
}

export default lang
